<template>
  <div id="system_admins_users_list">
    <CardedTable
      :items="items"
      :headers="headers"
      :height="is_adding_admin ? 300 : 550"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn
          @click="on_remove_admin(item)"
          x-small
          rounded
          outlined
          class="ml-2"
          color="red"
        >
          Remove Admin
        </v-btn>
      </template>
    </CardedTable>
  </div>
</template>

<script>
import CardedTable from "../../../components/CardedTable";
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
export default {
  name: "AdminSystemAdminsList",
  components: {
    CardedTable,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => {
        return ServerClient.Login.get_logged_in_user();
      },
    },
    is_adding_admin: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      _user: null,
      items: [],
      headers: [
        {
          text: "ID",
          align: "start",
          sortable: true,
          value: "id",
          filterable: true,
        },
        {
          text: "User Name",
          align: "start",
          sortable: false,
          value: "email",
          filterable: true,
        },
        {
          text: "First Name",
          align: "start",
          sortable: false,
          value: "first_name",
          filterable: true,
        },
        {
          text: "Last Name",
          align: "start",
          sortable: true,
          value: "last_name",
          filterable: true,
        },
        {
          text: "Status",
          align: "center",
          sortable: true,
          value: "status",
          filterable: true,
        },
        { text: "", value: "actions", sortable: false, align: "end" },
      ],
    };
  },
  methods: {
    load_items() {
      this.$emit("on-show-loader");
      ServerClient.Security.get_system_admin_users(
        {},
        (res) => {
          this.$emit("on-hide-loader");
          this.items = res;
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading system admin users list",
            errors
          );
        }
      );
    },
    on_remove_admin(item) {
        this.$router.push("/admin/users/admin/list/" + item.id + "/delete");
    }
  },
  mounted() {
    this._user = ServerClient.Login.get_logged_in_user();
    this.$emit("set-page-attributes", {
      title: "System Administrators",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Users",
          disabled: false,
          href: "/admin/users",
        },
        {
          text: "Admins",
          disabled: true,
          href: "/admin/users/admin/list",
        },
      ],
    });
    this.load_items();
    var options = {
    offset: 50,
    duration: 1000,
    easing: "easeInOutCubic",
    };
    this.$vuetify.goTo("#system_admins_users_list", options);
  },
};
</script>